export default __webpack_public_path__ + "static/media/@gabynotini.933e3399.jpg";